import React, { ReactNode } from 'react';
import classNames from 'classnames';

import './main-title.scss';

const MainTitle: React.FC<{
    htmlTag?: 'h1' | 'h2';
    text: ReactNode;
    className?: string;
    children?: ReactNode;
}> = ({ text, className, children, htmlTag = 'h1' }) => {
    return (
        <div className={classNames({
            'main-title': true,
            [String(className)]: Boolean(className)
        })}
        >
            {htmlTag === 'h1'
                ? (
                    <h1 className="primary">
                        {text}
                    </h1>
                )
                : (
                    <h2 className="primary">
                        {text}
                    </h2>
                )
            }
            <span className="secondary">
                {children}
            </span>
        </div>
    );
};

export default MainTitle;
